{
  "conversations": {
    "conversationsApp": "App de conversas",
    "locationId": "ID de localização",
    "idToken": "Token de ID",
    "conversationRoutes": "Rotas de conversa",
    "conversationProviders": "Provedores de conversas",
    "viewTheListOfConversation": "Exibido os provedores da Lista de conversas personalizadas adicionados à Conta aqui.",
    "logo": "Logotipo",
    "name": "Nome",
    "alias": "Alias",
    "type": "Digitar"
  }
}
